<template>
  <StButton
    type="text-primary"
    :label
    :icon
    is-left-icon
    size="xs"
    @click="redirectToOtherPlatform"
  />
</template>

<script setup lang="ts">
import { useLinkToOtherPlatform } from '@st/i18n-base/composables'
import type { IconName } from '@st/ui/components/StIcon/types'

const { linkToOtherPlatform, otherPlatform } = useLinkToOtherPlatform()

const { t } = useI18n()

const label = computed(() =>
  otherPlatform.value === 'mobile'
    ? t('footer.mobileVersion')
    : t('footer.desktopVersion'),
)

const icon = computed<IconName>(() =>
  otherPlatform.value === 'mobile' ? 'mobile-solid' : 'monitor',
)

function redirectToOtherPlatform() {
  window.location.href = linkToOtherPlatform.value
}
</script>
